import { React, useEffect, useState } from "react";
import "./FormulaCreation.css";
import {
  Col,
  DatePicker,
  Row,
  Button,
  Spin,
  Form,
  Input,
  InputNumber,
  Select,
  Table,
  Tag,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { antIcon, formatCapabilities } from "../../../Helpers/helpers";
import ButtonComp from "../../ButtonComp/ButtonComp";
import { CheckCircleFilled } from "../../../Utils/imports";
import SyncMachine from "../SyncMachine/SyncMachine";
import * as math from "mathjs";

const FormulaCreation = () => {
  const [formulaState, setFormulaState] = useState({
    formula1: "",
    formula1Correct: true,
    formula1Raw: "",
    formula1String: "",
    formula2: "",
    formula2Correct: true,
    formula2Raw: "",
    formula2String: "",
    formula3: "",
    formula3Correct: true,
    formula3Raw: "",
    formula3String: "",
    formula4: "",
    formula4Correct: true,
    formula4Raw: "",
    formula4String: "",
    formula5: "",
    formula5Correct: true,
    formula5Raw: "",
    formula5String: "",
    formula6: "",
    formula6Correct: true,
    formula6Raw: "",
    formula6String: "",
    isRejectionSelected: 0,
  });
  
  let { current } = useSelector((state) => state?.plant);
  let machinearr = [current?.machine?.machineName];
  let {
    plant = null,
    machine = null,
    line = null,
  } = JSON.parse(localStorage.getItem("current"));
  const [selectedMachines, setState] = useState([]);
  const [resultValue, setResultValue] = useState(0);
  const [formula1Input, setFormula1Input] = useState("");
  const [formula2Input, setFormula2Input] = useState("");

  const resetFormulaInput = () => {
    const { isRejectionSelected } = formulaState;
    const formulaKey = `formula${isRejectionSelected + 1}`;
    setFormulaState({
      ...formulaState,
      [formulaKey]: "",
      [`${formulaKey}Correct`]: true,
      [`${formulaKey}Raw`]: "",
      [`value${isRejectionSelected + 1}`]: 0,
      [`${formulaKey}String`]: "",
    });
  };

  const sync = async () => {};

  const dataSource = [
    { id: "Sensor 1", name: "80" },
    { id: "Sensor 2", name: "122" },
    { id: "Downtime", name: "160" },
    { id: "Primary", name: "160" },
    { id: "Secondary", name: "160" },
  ];

  const columns = [
    {
      // title: 'ID',
      dataIndex: "id",
      key: "id",
    },
    {
      // title: 'Name',
      dataIndex: "name",
      key: "name",
    },
  ];

  const setFormula = (text, isNum = false) => {
    setFormulaState((prevFormulaState) => {
      let rawText =
        prevFormulaState[
          `formula${prevFormulaState.isRejectionSelected + 1}Raw`
        ];
      let stringFormula =
        prevFormulaState[
          `formula${prevFormulaState.isRejectionSelected + 1}String`
        ];

      rawText =
        rawText +
        (isNum ? prevFormulaState.snapshot[text] : text === "x" ? "*" : text) +
        " ";
      stringFormula =
        stringFormula + (isNum ? text : text === "x" ? "*" : text) + " ";

      let formulaCorrect = true;
      try {
        let value = math.evaluate(rawText); 
        prevFormulaState[`value${prevFormulaState.isRejectionSelected + 1}`] =
          value;
      } catch (err) {
        formulaCorrect = false;
      }
      console.log({
        [`formula${prevFormulaState.isRejectionSelected + 1}`]:
          prevFormulaState[
            `formula${prevFormulaState.isRejectionSelected + 1}`
          ] +
          text +
          " ",
        [`formula${prevFormulaState.isRejectionSelected + 1}Correct`]:
          formulaCorrect,
        [`formula${prevFormulaState.isRejectionSelected + 1}Raw`]: rawText,
        [`formula${prevFormulaState.isRejectionSelected + 1}String`]:
          stringFormula,
      });

      try {
        const value = math.evaluate(rawText); 
        setResultValue(Math.round(value));
      } catch (err) {
        setResultValue(0);
      }

      return {
        ...prevFormulaState,
        [`formula${prevFormulaState.isRejectionSelected + 1}`]:
          prevFormulaState[
            `formula${prevFormulaState.isRejectionSelected + 1}`
          ] +
          text +
          " ",
        [`formula${prevFormulaState.isRejectionSelected + 1}Correct`]:
          formulaCorrect,
        [`formula${prevFormulaState.isRejectionSelected + 1}Raw`]: rawText,
        [`formula${prevFormulaState.isRejectionSelected + 1}String`]:
          stringFormula,
      };
    });
  };

  const calculateResults = () => {
    const formulaInputs = {
   
    };

    setFormula("GoodOutputs", true);
    setFormula("Rejections", true);
    setFormula("Downtime", true);
    setFormula("MS Downtime", true);
    setFormula("Current MS", true);
    setFormula("RSSI", true);
  };
  const generateResultString = () => {
    const { formula1, formula2, formula3, formula4, formula5, formula6, formula7, formula8, formula9, formula10 } = formulaState;

    const sensor1 = 80;
    const sensor2 = 122;
    const downtime = 160;
    const primary = 160;
    const secondary = 160;

    try {
      const formulaResult = math.evaluate(formula1, { Sensor1: sensor1, Sensor2: sensor2, Downtime: downtime, Primary: primary, Secondary: secondary });
      console.log(`Sensor 1 = ${sensor1}, Sensor 2 = ${sensor2}, Downtime = ${downtime}, Primary = ${primary}, Secondary = ${secondary}`);
    } catch (err) {
      console.log('Error in evaluating the formula:', err.message);
    }
  };

  return (
    <>
      <Row className="pt1">
        <Col span={12}>
          <h1 className="pageHead">Formula Creation</h1>
        </Col>
      </Row>
      <Row className="pt1">
        <Col span={8}>
          <Row className="width100P">
            <Col span={24}>
              <Form>
                <div className="boxBorder boxBorderRad p10">
                  <div className="dflex alignCenter justifySB">
                    <h4>Inputs</h4>
                  </div>
                  <Input
                    readOnly={true}
                    className="IARP-form-input boxBorder boxBorderRad boxBg"
                    style={{ textAlign: "center" }}
                    defaultValue={"Board Inputs"}
                  />
                  <div className="buttonRow dflex width100P">
                    <Button
                      type="primary"
                      className="inputButton boxBorder"
                      onClick={() => setFormula("Sensor 1")}
                    >
                      Sensor 1
                    </Button>
                    <div className="buttonGap" />
                    <Button
                      type="primary"
                      className="inputButton boxBorder"
                      onClick={() => setFormula("Sensor 2")}
                    >
                      Sensor 2
                    </Button>
                  </div>
                  <div className="buttonRow dflex width100P">
                    <Button
                      type="primary"
                      className="inputButton boxBorder"
                      onClick={() => setFormula("Downtime")}
                    >
                      Downtime
                    </Button>
                    <div className="buttonGap" />
                    <Button
                      type="primary"
                      className="inputButton boxBorder"
                      onClick={() => setFormula("Primary")}
                    >
                      Primary
                    </Button>
                  </div>
                  <div className="buttonRow dflex width100P">
                    <Button
                      type="primary"
                      className="inputButton boxBorder"
                      onClick={() => setFormula("Secondary")}
                    >
                      Secondary
                    </Button>
                  </div>
                </div>
              </Form>
            </Col>
          </Row>
          <Row className="pt10 width100P">
            <Col span={24}>
              <Form>
                <div className="boxBorder boxBorderRad p10">
                  <Input
                    readOnly={true}
                    className="IARP-form-input boxBorder boxBorderRad boxBg"
                    style={{ textAlign: "center" }}
                    defaultValue={"Arithmetic Symbols"}
                  />
                  <div className="buttonRow dflex width100P">
                    <Button
                      type="primary"
                      className="inputButton boxBorder"
                      onClick={() => setFormula("+")}
                    >
                      +
                    </Button>
                    <div className="buttonGap" />
                    <Button
                      type="primary"
                      className="inputButton boxBorder"
                      onClick={() => setFormula("-")}
                    >
                      -
                    </Button>
                    <div className="buttonGap" />
                    <Button
                      type="primary"
                      className="inputButton boxBorder"
                      onClick={() => setFormula("*")}
                    >
                      *
                    </Button>
                  </div>
                  <div className="buttonRow dflex width100P">
                    <Button
                      type="primary"
                      className="inputButton boxBorder"
                      onClick={() => setFormula("/")}
                    >
                      /
                    </Button>
                    <div className="buttonGap" />
                    <Button
                      type="primary"
                      className="inputButton boxBorder"
                      onClick={() => setFormula("(")}
                    >
                      (
                    </Button>
                    <div className="buttonGap" />
                    <Button
                      type="primary"
                      className="inputButton boxBorder"
                      onClick={() => setFormula(")")}
                    >
                      )
                    </Button>
                  </div>
                </div>
              </Form>
            </Col>
          </Row>
          <Row className="pt10 width100P">
            <Col span={24}>
              <Form>
                <div className="boxBorder boxBorderRad p10">
                  <div className="dflex alignCenter justifySB">
                    <h4>Configure Endpoints</h4>
                  </div>
                  <Form.Item name="machine">
                    <Select
                      mode="single"
                      placeholder="Parent Machines"
                      // onChange={handleParentMachineChange}
                      // value={parentMachine}
                      style={{ width: "100%" }}
                    >
                      {machinearr.map((machine) => (
                        <Select.Option key={machine} value={machine}>
                          {formatCapabilities(machine)}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item name="machine">
                    <Select
                      mode="multiple"
                      placeholder="Machines"
                      // onChange={handleEndpointsChange}
                      // disabled={!superadmin}
                      // value={endpointDict[parentMachine]}
                      style={{ width: "100%" }}
                    >
                      {machinearr.map((machine) => (
                        <Select.Option key={machine} value={machine}>
                          {formatCapabilities(machine)}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {/* <Form.Item className="width100P dflex alignCenter justifyFE pt10"> */}
                  <div
                    className="width100P dflex alignCenter justifyFE"
                    // style={{ paddingTop: "5px" }}
                  >
                    <ButtonComp
                      htmlType="submit"
                      theme="blue"
                      icon={<CheckCircleFilled />}
                      text="Save"
                    />
                  </div>
                  {/* </Form.Item> */}
                </div>
              </Form>
            </Col>
          </Row>
        </Col>
        <Col span={16}>
          <Row className="width100P pl10">
            <Col span={24}>
              <Form>
                <div className="boxBorder boxBorderRad p10">
                  <div className="dflex alignCenter justifySB">
                    <h4>Formula</h4>
                  </div>
                  <div className="dflex width100P pl10 justifyCenter alignCenter">
                    <span style={{ width: "20%" }}>Good Outputs</span>
                    <Input
                      className="boardInput boxBorder boxBorderRad boxBg"
                      // disabled={!formulaState.superadmin}
                      onClick={() => {
                        if (formulaState.isRejectionSelected !== 0) {
                          setFormulaState({
                            ...formulaState,
                            isRejectionSelected: 0,
                          });
                        }
                      }}
                      id="formula1"
                      style={{
                        width: "100%",
                        borderColor: formulaState.formula1Correct
                          ? formulaState.isRejectionSelected === 0
                            ? "green"
                            : "#D9D9D9"
                          : "red",
                        color: "transparent",
                        textShadow: `0 0 0 ${
                          formulaState.isRejectionSelected === 0
                            ? "green"
                            : "black"
                        }`,
                      }}
                      value={formulaState.formula1}
                    />
                    {/* <div style={{ width: "10%", float: "left", padding: 5 }}>
                      {formulaState.superadmin && (
            <CloseCircleOutlined onClick={resetFormulaInput} style={{ cursor: 'pointer' }} />
          )}
                    </div> */}
                  </div>
                  <div
                    className="dflex width100P pl10 justifyCenter alignCenter"
                    style={{ paddingTop: "5px" }}
                  >
                    <span style={{ width: "20%" }}>Rejections</span>
                    <Input
                      className="boardInput boxBorder boxBorderRad boxBg"
                      // disabled={!formulaState.superadmin}
                      onClick={() => {
                        if (formulaState.isRejectionSelected !== 1) {
                          setFormulaState({
                            ...formulaState,
                            isRejectionSelected: 1,
                          });
                        }
                      }}
                      text
                      id="formula2"
                      style={{
                        width: "100%",
                        // height: 40,
                        borderColor: formulaState.formula2Correct
                          ? formulaState.isRejectionSelected === 1
                            ? "green"
                            : "#D9D9D9"
                          : "red",
                        color: "transparent",
                        textShadow: `0 0 0 ${
                          formulaState.isRejectionSelected === 1
                            ? "green"
                            : "black"
                        }`,
                      }}
                      value={formulaState.formula2}
                    />
                  </div>
                  <div
                    className="dflex width100P pl10 justifyCenter alignCenter"
                    style={{ paddingTop: "5px" }}
                  >
                    <span style={{ width: "20%" }}>Downtime</span>
                    <Input
                      className="boardInput boxBorder boxBorderRad boxBg"
                      // disabled={!formulaState.superadmin}
                      onClick={() => {
                        if (formulaState.isRejectionSelected !== 2) {
                          setFormulaState({
                            ...formulaState,
                            isRejectionSelected: 2,
                          });
                        }
                      }}
                      text
                      id="formula2"
                      style={{
                        width: "100%",
                        // height: 40,
                        borderColor: formulaState.formula3Correct
                          ? formulaState.isRejectionSelected === 2
                            ? "green"
                            : "#D9D9D9"
                          : "red",
                        color: "transparent",
                        textShadow: `0 0 0 ${
                          formulaState.isRejectionSelected === 2
                            ? "green"
                            : "black"
                        }`,
                      }}
                      value={formulaState.formula3}
                    />
                  </div>
                  <div
                    className="dflex width100P pl10 justifyCenter alignCenter"
                    style={{ paddingTop: "5px" }}
                  >
                    <span style={{ width: "20%" }}>MS Downtime</span>
                    <Input
                      className="boardInput boxBorder boxBorderRad boxBg"
                      // disabled={!formulaState.superadmin}
                      onClick={() => {
                        if (formulaState.isRejectionSelected !== 3) {
                          setFormulaState({
                            ...formulaState,
                            isRejectionSelected: 3,
                          });
                        }
                      }}
                      text
                      id="formula2"
                      style={{
                        width: "100%",
                        // height: 40,
                        borderColor: formulaState.formula4Correct
                          ? formulaState.isRejectionSelected === 3
                            ? "green"
                            : "#D9D9D9"
                          : "red",
                        color: "transparent",
                        textShadow: `0 0 0 ${
                          formulaState.isRejectionSelected === 3
                            ? "green"
                            : "black"
                        }`,
                      }}
                      value={formulaState.formula4}
                    />
                  </div>
                  <div
                    className="dflex width100P pl10 justifyCenter alignCenter"
                    style={{ paddingTop: "5px" }}
                  >
                    <span style={{ width: "20%" }}>Current MS</span>
                    <Input
                      className="boardInput boxBorder boxBorderRad boxBg"
                      // disabled={!formulaState.superadmin}
                      onClick={() => {
                        if (formulaState.isRejectionSelected !== 4) {
                          setFormulaState({
                            ...formulaState,
                            isRejectionSelected: 4,
                          });
                        }
                      }}
                      text
                      id="formula2"
                      style={{
                        width: "100%",
                        // height: 40,
                        borderColor: formulaState.formula5Correct
                          ? formulaState.isRejectionSelected === 4
                            ? "green"
                            : "#D9D9D9"
                          : "red",
                        color: "transparent",
                        textShadow: `0 0 0 ${
                          formulaState.isRejectionSelected === 4
                            ? "green"
                            : "black"
                        }`,
                      }}
                      value={formulaState.formula5}
                    />
                  </div>
                  <div
                    className="dflex width100P pl10 justifyCenter alignCenter"
                    style={{ paddingTop: "5px" }}
                  >
                    <span style={{ width: "20%" }}>RSSI</span>
                    <Input
                      className="boardInput boxBorder boxBorderRad boxBg"
                      // disabled={!formulaState.superadmin}
                      onClick={() => {
                        if (formulaState.isRejectionSelected !== 5) {
                          setFormulaState({
                            ...formulaState,
                            isRejectionSelected: 5,
                          });
                        }
                      }}
                      text
                      id="formula2"
                      style={{
                        width: "100%",
                        // height: 40,
                        borderColor: formulaState.formula6Correct
                          ? formulaState.isRejectionSelected === 5
                            ? "green"
                            : "#D9D9D9"
                          : "red",
                        color: "transparent",
                        textShadow: `0 0 0 ${
                          formulaState.isRejectionSelected === 5
                            ? "green"
                            : "black"
                        }`,
                      }}
                      value={formulaState.formula6}
                    />
                  </div>
                  <div
                    className="dflex width100P pl10 justifyCenter alignCenter"
                    style={{ paddingTop: "5px" }}
                  >
                    <span style={{ width: "20%" }}>Results</span>
                    <Input
                      className="boardInput boxBorder boxBorderRad boxBg"
                      // disabled={!formulaState.superadmin}

                      text
                      id="result"
                      style={{
                        width: "100%",
                        // height: 40,
                      }}
                      value={resultValue}
                    />
                  </div>
                  <div
                    className="width100P dflex alignCenter justifyFE"
                    style={{ paddingTop: "5px" }}
                  >
                    <ButtonComp
                      htmlType="submit"
                      theme="blue"
                      icon={<CheckCircleFilled />}
                      text="Save"
                    />
                  </div>
                </div>
              </Form>
            </Col>
          </Row>
          <Row className="pt10 width100P pl10">
            <Col span={24}>
              <Form>
                <Table
                  className="formulaTable"
                  columns={columns}
                  dataSource={dataSource}
                  pagination={false}
                  showHeader={false}
                />
              </Form>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="width100P">
        <Col span={24}>
          <Form>
            <SyncMachine
              machine={machine}
              //  canSync={(x) => canSync(x)}
              selectedMachines={selectedMachines}
              sync={sync}
              productionLine={current?.line?.productionLine}
              changeMachines={(machines) => {
                setState(machines);
              }}
            />
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default FormulaCreation;
